<template lang="pug">
div(v-if="billing && Object.keys(billing).length > 0" class="mb-3")
  h3(class="text-xs font-semibold mb-2 text-muted-foreground uppercase tracking-wider") Billing Address
  div(class="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm")
    div(v-if="billingName")
      span.text-xs.text-muted-foreground.block Name
      span {{ billingName }}
    div(v-if="billing.company_name")
      span.text-xs.text-muted-foreground.block Company
      span {{ myunescape(billing.company_name) }}
    div(v-if="billing.addr")
      span.text-xs.text-muted-foreground.block Address
      span {{ myunescape(billing.addr) }}
    div(v-if="billing.city")
      span.text-xs.text-muted-foreground.block City
      span {{ myunescape(billing.city) }}
    div(v-if="billing.state")
      span.text-xs.text-muted-foreground.block State
      span {{ myunescape(billing.state) }}
    div(v-if="billing.zip")
      span.text-xs.text-muted-foreground.block ZIP
      span {{ myunescape(billing.zip) }}
    div(v-if="billing.country")
      span.text-xs.text-muted-foreground.block Country
      span {{ myunescape(billing.country) }}
    div(v-if="billing.company_vat")
      span.text-xs.text-muted-foreground.block VAT
      span {{ myunescape(billing.company_vat) }}
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { myunescape } from '~/utils/escape'

const props = defineProps<{
  billing: any
}>()

const billingName = computed(() => {
  if (!props.billing) return ''
  const firstName = myunescape(props.billing.firstname || '')
  const lastName = myunescape(props.billing.lastname || '')
  return [firstName, lastName].filter(Boolean).join(' ')
})
</script>